@let opkraevning =
  leverandoerOpkraevningService.selectedLeverandoerOpkraevning();
@if (opkraevning) {
  <div class="flex flex-col overflow-hidden h-full">
    <h2>Leverandør opkrævning</h2>
    <table class="detail-table">
      <tr>
        <td class="detail-label">Regnr</td>
        <td>{{ opkraevning.pengeinstitut.regnr }}</td>
      </tr>
      <tr>
        <td class="detail-label">Periode</td>
        <td>
          {{
            opkraevning.leverandoerOpkraevningPeriode.opkraevningsPeriodeFra
              | date: 'dd-MM-yyyy'
          }}
          -
          {{
            opkraevning.leverandoerOpkraevningPeriode.opkraevningsPeriodeTil
              | date: 'dd-MM-yyyy'
          }}
        </td>
      </tr>
      <tr>
        <td class="detail-label">Udsendt</td>
        <td>{{ opkraevning.udsendt | date: 'dd-MM-yyyy' }}</td>
      </tr>
      <tr>
        <td><h3>Opkrævning</h3></td>
      </tr>
      <tr>
        <td class="detail-label">Antal opkrævninger</td>
        <td>{{ opkraevning.antalOpkraevninger | number: '1.0' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Samlet opkrævning</td>
        <td>{{ opkraevning.sumOpkraevninger | number: '1.2' }}</td>
      </tr>
    </table>
    <div class="mb-4 flex gap-4">
      <p-button
        icon="pi pi-file-excel"
        label="Hent regneark"
        outlined
        (click)="onClickExport(opkraevning.id)"></p-button>
      <p-button
        icon="pi pi-file-pdf"
        label="Hent faktura"
        outlined
        (click)="onClickHentFaktura(opkraevning.id)"></p-button>
    </div>

    <div class="flex-1 overflow-hidden">
      <p-table
        [value]="risikoOpkraevninger().data"
        [loading]="risikoOpkraevningDatasource.isLoading()"
        [showGridlines]="true"
        [scrollable]="true"
        scrollHeight="flex"
        stripedRows
        class="p-datatable-sm lp-table"
        selectionMode="single"
        [metaKeySelection]="true"
        (onRowSelect)="onRowSelect($event)"
        dataKey="id"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        (onLazyLoad)="onLazyLoad($event)"
        sortField="raadgiver.fornavn"
        [sortOrder]="1"
        [paginator]="true"
        [rows]="100"
        [totalRecords]="risikoOpkraevninger().totalRowCount"
        [showJumpToPageDropdown]="true"
        letKeepScrollPosition>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="id">
              Reference
              <p-sortIcon field="id" />
            </th>
            <th pSortableColumn="periodeFra">
              Periode
              <p-sortIcon field="periodeFra" />
            </th>
            <th pSortableColumn="produktTypeNummer">
              Produkt
              <p-sortIcon field="produktTypeNummer" />
            </th>
            <th pSortableColumn="opkraevningsType">
              Type
              <p-sortIcon field="opkraevningsType" />
            </th>
            <th pSortableColumn="opkraevningsBeloeb">
              Beløb
              <p-sortIcon field="opkraevningsBeloeb" />
            </th>
            <th pSortableColumn="provision">
              Provision
              <p-sortIcon field="provision" />
            </th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template
          [appTableRow]="risikoOpkraevninger().data"
          pTemplate="body"
          let-item>
          <tr [pSelectableRow]="item" class="cursor-pointer">
            <td>{{ item.id }}</td>
            <td>
              {{ item.periodeFra | date: 'dd-MM-yyyy' }} -
              {{ item.periodeTil | date: 'dd-MM-yyyy' }}
            </td>
            <td>{{ item.produktTypeNummer }}</td>
            <td>{{ item.opkraevningsType }}</td>
            <td class="numbers !text-right">
              {{ item.opkraevningsBeloeb | number: '1.2' }}
            </td>
            <td class="numbers !text-right">
              {{ item.provision | number: '1.2' }}
            </td>
            <td>{{ item.opkraevningStatus }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
<p-dialog
  header="Risikoopkrævning"
  [modal]="true"
  [(visible)]="visRisikoOpkraevning"
  [style]="{
    width: '1000px',
    maxHeight: '90%',
  }">
  @if (risikoOpkraevning()) {
    <app-risiko-opkraevning-detail [risikoOpkraevning]="risikoOpkraevning()!" />
  }
</p-dialog>
